import React, {useEffect, useState} from "react";
import PanelRightContent from "../../../layouts/mainPanel/PanelRightContent";
import MainPanelHeader from "../../../layouts/mainPanelHeader";
import PanelLeftContent from "../../../layouts/mainPanel/PanelLeftContent";
import SmallCoin from "../../../asset/image/small-coin.png";
import {Tab, Tabs} from "react-bootstrap";
import {ReactComponent as OtherDots} from "../../../asset/icons/otherDotsIcon.svg";
import {ReactComponent as WalletIcon} from "../../../asset/icons/walletIcon.svg";
import WalletModal from "../../../component/global/WalletModal";
import {get} from "../../../controlers/global/ConfigRequest";
import {GET_USER_MONEY_COINS_UR} from "../../../helperData/ApiAddress";
import Bests from "./Bests";
import {CartesianGrid, Line, LineChart, ResponsiveContainer, XAxis, YAxis,} from "recharts";

import UsedCards from "./UsedCards";
import PointsHistory from "./PointsHistory";
import DiscountCardDetailModal from "./DiscountCardDetailModal";
import {useTranslation} from "react-i18next";
import "./style.scss";

const data = [
  {
    name: "مهر",
    uv: 20,
    pv: 80,
  },
  {
    name: "آبان",
    uv: 60,
    pv: 60,
  },
  {
    name: "آذر",
    uv: 40,
    pv: 50,
  },
  {
    name: "دی",
    uv: 80,
    pv: 7,
  },
  {
    name: "بهمن",
    uv: 60,
    pv: 10,
  },
];

export default function UserDiscount() {
  const [coins, setCoins] = useState();
  const [money, setMoney] = useState();
  const {t} = useTranslation()

  useEffect(() => {
    // getUserMoneyCoins
    get(GET_USER_MONEY_COINS_UR).then((r) => {
      setCoins(r[1]?.balance);
      setMoney(r[0]?.balance);
    });
  }, []);

  const [activeTab, setActiveTab] = useState("1");
  const [walletModalState, setWalletModalState] = useState(false);
  const [detailModalShow, setDetailModalShow] = useState(false);
  const [detailModalId, setDetailModalId] = useState(0);
  const [detailModalIsArchive, setDetailModalIsArchive] = useState(false);

  const detailModalHandle = (id, archive) => {
    setDetailModalShow(true);
    setDetailModalId(id);
    setDetailModalIsArchive(!!archive);
  };

  return (
    <div
      id="user-discount"
      className="main_panel_box user-profile discount-container"
    >
      <DiscountCardDetailModal
        show={detailModalShow}
        onHide={() => {
          setDetailModalShow(false);
        }}
        id={detailModalId}
        archive={detailModalIsArchive}
      />
      {/*<DiscountCardDetailModal_old*/}
      {/*  show={detailModalShow}*/}
      {/*  onHide={() => {*/}
      {/*    setDetailModalShow(false);*/}
      {/*  }}*/}
      {/*  id={detailModalId}*/}
      {/*  archive={detailModalIsArchive}*/}
      {/*/>*/}
      <MainPanelHeader/>
      <WalletModal
        showModal={walletModalState}
        closeModal={(_) => setWalletModalState(false)}
        money={money}
        coins={coins}
      />
      <div className="user-profile_content main_panel_content">
        <PanelRightContent>
          <div className="tab-section">
            <Tabs
              activeKey={activeTab}
              transition={false}
              className="panel_tab"
              onSelect={(e) => setActiveTab(e)}
            >
              <Tab
                eventKey="1"
                className="panel_tab_item"
                title={t('Src.Pages.UserPages.UserDiscount.Tab.DiscountCard')}
              >
                <Bests onClick={detailModalHandle}/>
              </Tab>
              <Tab
                eventKey="2"
                className="panel_tab_item"
                title={t('Src.Pages.UserPages.UserDiscount.Tab.DiscountHistory')}
              >
                <UsedCards setId={detailModalHandle}/>
              </Tab>
              <Tab
                eventKey="3"
                className="panel_tab_item"
                title={t('UserPanel.Offers.Tab.Points')}
              >
                <PointsHistory />
              </Tab>
            </Tabs>
          </div>
        </PanelRightContent>
        <PanelLeftContent>
          <div className="left-section">
            <div className="chart-title">
              <img src={SmallCoin} alt="coin"/>{" "}
              <span>باشگاه مشتریان</span>
              <button className="more-dots ratings-btn">
                <OtherDots/>
              </button>
            </div>
            <div className="charts">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart
                  width={500}
                  height={300}
                  data={data}
                  margin={{
                    top: 10,
                    right: 0,
                    left: -40,
                    bottom: -10,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3"/>
                  <XAxis dataKey="name"/>
                  <YAxis tickMargin={15}/>
                  <Line
                    type="monotone"
                    dataKey="uv"
                    stroke="#FEB730"
                    strokeWidth={2}
                    activeDot={{r: 8}}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className="left-section">
            <div className="chart-title">
              <img src={SmallCoin} alt="coin"/>{" "}
              <span>باشگاه مشتریان</span>
              <button className="more-dots ratings-btn">
                <OtherDots/>
              </button>
            </div>
            <div className="charts">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart
                  width={500}
                  height={300}
                  data={data}
                  margin={{
                    top: 10,
                    right: 0,
                    left: -40,
                    bottom: -10,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3"/>
                  <XAxis dataKey="name"/>
                  <YAxis tickMargin={15}/>
                  <Line
                    type="monotone"
                    dataKey="uv"
                    stroke="#FEB730"
                    strokeWidth={2}
                    activeDot={{r: 8}}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className="left-section">
            <div className="chart-title">
              <WalletIcon/>
              <div>کیف پول</div>
            </div>
            <div className="wallet">
              <div>موجودی کیف پول</div>
              <div>
                تومان<span>{money || "-"}</span>
              </div>
              <div className="btn-group">
                <button
                  className=" blue"
                  onClick={(_) => setWalletModalState(true)}
                >
                  شارژ کیف پول
                </button>
              </div>
            </div>
          </div>
        </PanelLeftContent>
      </div>
    </div>
  );
}
